import { render, staticRenderFns } from "./WorkPosition.vue?vue&type=template&id=23ebcb64"
import script from "./WorkPosition.vue?vue&type=script&lang=js"
export * from "./WorkPosition.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports